<form [formGroup]="PageForm" (ngSubmit)="submitPageForm()" class="Page-form" novalidate >
  <button mat-button type="submit"  [disabled]="disableBtn"class="btn btn-save mat-submit-button">Submit</button>
  <div >
    <mat-form-field appearance="outline"  class="full-width">
      <mat-label>Key</mat-label>
      <input matInput  formControlName="_key"  />

    </mat-form-field>
  </div>
  <div >
    <mat-form-field appearance="outline" class="full-width" >
      <mat-label>Title</mat-label>
      <input matInput  formControlName="title" required />
     
    </mat-form-field>
  </div>
  <div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Content</mat-label>
      <qeditor
        formControlName="content"
        placeholder="Type your wisdom here..."
      ></qeditor>
      @if (PageForm?.get('content')?.hasError('required')) {
        <mat-error>
          Field is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" >
      <mat-label>PageType</mat-label>
      <mat-select matNativeControl  formControlName="pageType" required>
        @for (nnI of pageT; track nnI) {
          <mat-option [value]="nnI">
            {{ nnI }}
          </mat-option>
        }
      </mat-select>

    </mat-form-field>
    <mat-form-field appearance="outline" >
      <mat-label>Access key</mat-label>
      <input matInput  formControlName="accessKey" />

    </mat-form-field>
    <mat-form-field>
      <ngx-mat-file-input2 [formControl]="fileControl">
      </ngx-mat-file-input2>
    </mat-form-field>
  </div>
  <button mat-button type="submit" [disabled]="disableBtn" class="btn btn-save mat-submit-button">Submit</button>
  <div>
    @if (image) {
      <img src="{{image}}" alt="Page Image">
    }
  </div>
</form>

